const STATE_KEY = 'ordersNewBackGuard'
const MESSAGE = '點餐頁面禁止使用瀏覽器「上一頁」，以免遺失目前的訂單。請使用頁面內的功能操作。'

// Window 的 popstate 依註冊順序執行，必須在 Turbo 啟動前先註冊。
export function createOrderBackNavigationGuard(browser) {
  let handlePopState = null
  // 重新整理時 Turbo 會取代 history.state，先保留既有標記以免堆疊同頁紀錄。
  let initialMarker = browser.history.state?.[STATE_KEY]
  browser.addEventListener('popstate', (event) => handlePopState?.(event), true)

  return () => {
    handlePopState = installGuard(browser, initialMarker)
    initialMarker = null
    const installedHandler = handlePopState
    return () => {
      if (handlePopState === installedHandler) handlePopState = null
    }
  }
}

function installGuard(browser, initialMarker) {
  const { history, location } = browser
  const url = location.href
  const marker = history.state?.[STATE_KEY] ?? initialMarker
  const id = marker?.url === url ? marker.id : `${Date.now()}-${Math.random()}`

  const pushGuard = () => {
    // 保留 Turbo 的 restoration 資訊，避免影響其他頁面的歷史導航。
    history.pushState({
      ...history.state,
      [STATE_KEY]: { id, url, guard: true }
    }, '', url)
  }

  if (marker?.url === url && marker.guard) {
    history.replaceState({ ...history.state, [STATE_KEY]: marker }, '', url)
  } else {
    history.replaceState({
      ...history.state,
      [STATE_KEY]: { id, url, guard: false }
    }, '', url)
    pushGuard()
  }

  const onPopState = (event) => {
    const destination = event.state?.[STATE_KEY]
    if (destination?.id !== id || destination.guard) return

    // popstate 無法取消；在 Turbo 收到事件前阻止重建畫面，並補回同頁紀錄。
    event.stopImmediatePropagation()
    pushGuard()
    browser.alert(MESSAGE)
  }

  return onPopState
}

export const installOrderBackNavigationGuard = typeof window === 'undefined'
  ? null
  : createOrderBackNavigationGuard(window)
